import rsMessages from '../locales/sr_RS.json';

const RsLang = {
  messages: {
    ...rsMessages,
  },
  locale: 'sr-RS',
};
export default RsLang;
